import { Navigate } from 'react-router-dom';

export default function PlayPage() {
  return <Navigate to="/auth" replace />;
}
